import { render, staticRenderFns } from "./StopSyncModal.vue?vue&type=template&id=4fbd5238"
import script from "./StopSyncModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StopSyncModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports